import PropTypes from 'prop-types';
import React from 'react';
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalActions,
} from '@99designs/react-components/components/Modal';
import { FormattedMessage } from 'react-intl';
import ButtonGroup, { ButtonGroupItem } from '@99designs/react-components/components/ButtonGroup';
import Button from '@99designs/react-components/components/Button';
import Avatar from '@99designs/react-components/components/Avatar';

const ConfirmRemoveContestFinalistModal = ({ user, onConfirm, onCancel }) => {
    return (
        <Modal
            isActive={true}
            isConfirmation={true}
            onClose={onCancel}
            variations={['confirmation', 'heritage']}
        >
            <ModalHeader>
                <Avatar user={user} variations={['medium', 'with-shadow']} isLinked={false} />
            </ModalHeader>
            <ModalBody>
                <FormattedMessage
                    id="contest_finalist_modal_button_message"
                    values={{ userName: user.displayName }}
                />
            </ModalBody>
            <ModalActions>
                <ButtonGroup variations={['responsive']}>
                    <ButtonGroupItem>
                        <Button onClick={onConfirm} type="button" variations={['primary', 'fluid']}>
                            <FormattedMessage id="contest_finalist_modal_button_remove" />
                        </Button>
                    </ButtonGroupItem>
                    <ButtonGroupItem>
                        <Button
                            onClick={onCancel}
                            variations={['secondary', 'fluid']}
                            type="button"
                        >
                            <FormattedMessage id="contest_finalist_modal_button_cancel" />
                        </Button>
                    </ButtonGroupItem>
                </ButtonGroup>
            </ModalActions>
        </Modal>
    );
};

ConfirmRemoveContestFinalistModal.propTypes = {
    onCancel: PropTypes.func.isRequired,
    onConfirm: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
};

export default ConfirmRemoveContestFinalistModal;



// WEBPACK FOOTER //
// ./src/web/js/contest/apps/entries/components/confirm-remove-contest-finalist-modal.jsx